// The printable area of each keycap type: the rectangle the texts and icons are placed in
// and clipped to, in mm from the keycap's top-left corner, as the customizer's and the order
// processing's KeycapOverlay pass it to RenderKeycapTexts and RenderKeycapIcons, which draw
// it as the printable-area outline and grid. The ISO Enter has two, its upper and its lower
// part; every other type has one, and null for the second. Keyed like the layout validator's
// keycap types (utils/layoutValidation.js), for the 20 types the overlays draw. Out of the two
// overlays' render loops, which held the same values (backfill PR 26).
const area = (x, y, width, height) => ({
  innerRect1X: x,
  innerRect1Y: y,
  innerRect1Width: width,
  innerRect1Height: height,
  innerRect2X: null,
  innerRect2Y: null,
  innerRect2Width: null,
  innerRect2Height: null,
});

export const keycapPrintableAreas = {
  '1x1': area(4.5736041, 4.574604, 9.9017916, 9.9017916),
  '1x1-homing-bar': area(4.5737133, 4.5737133, 9.9025736, 9.9025736),
  '1.25x1': area(4.5578961, 4.5308962, 14.696207, 9.9872074),
  '1.5x1': area(4.6209397, 4.5719399, 19.332119, 9.9061203),
  '1.75x1': area(4.7378254, 4.5678253, 23.86035, 9.9123497),
  '1.75x1-stepped': area(4.8338094, 4.6288095, 15.188381, 9.7933807),
  '2x1': area(4.9319954, 4.5799952, 28.23501, 9.8910093),
  '1x2': area(4.5798435, 4.9308434, 9.8913126, 28.235313),
  '2.25x1': area(4.8222976, 4.5782976, 33.216404, 9.8964052),
  '2.75x1': area(5.1010914, 4.6070914, 42.183819, 9.8358173),
  '1.5x2-iso-enter': {
    innerRect1X: 4.0630322,
    innerRect1Y: 4.1697917,
    innerRect1Width: 20.446352,
    innerRect1Height: 11.192497,
    innerRect2X: 8.6724024,
    innerRect2Y: 4.1704888,
    innerRect2Width: 15.83593,
    innerRect2Height: 29.761625,
  }, // the upper part and the lower part
  '1x1-convex': area(4.4392405, 4.3472404, 10.171519, 10.355519),
  '1.25x1-convex': area(4.5830188, 4.3590188, 14.645962, 10.350963),
  '1.75x1-convex': area(4.7592998, 4.3732996, 23.818399, 10.3044),
  '2x1-convex': area(4.6440129, 4.3770132, 28.810974, 10.297974),
  '2.25x1-convex': area(4.5307612, 4.3827615, 33.801479, 10.286477),
  '2.75x1-convex': area(4.7989988, 4.3859987, 42.792, 10.278003),
  '3x1-convex': area(4.6769795, 4.3839798, 47.79604, 10.280041),
  '6.25x1-convex': area(4.7880845, 4.3930845, 109.48483, 10.264831),
  '7x1-convex': area(4.6868238, 4.3898239, 123.97735, 10.268353),
};
